import { Flex, Text, Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import FigmaChartIcon from 'components/Icons/FigmaChartIcon';
import FigmaKpiIcon from 'components/Icons/FigmaKpiIcon';
import FigmaTableIcon from 'components/Icons/FigmaTableIcon';
import FigmaVarianceIcon from 'components/Icons/FigmaVarianceIcon';
import TextBoxIconComponent from 'components/Icons/TextBoxIcon';
import { getEditInstrumentData } from 'redux/DashboardSliceV2';

const DashboardModalHeading = () => {
  const widget = useSelector(getEditInstrumentData);

  return (
    <Flex
      alignItems={'center'}
      justifyContent='space-between'
      bg='white'
      borderBottom='1px solid #E8E9EB'
      p='18px'
      gap='11px'
    >
      <Box>
        {widget?.instrument_type === 'kpi' ? (
          <Flex alignItems={'center'} gap='11px'>
            <FigmaKpiIcon width={18} height={18} color={'#121826'} />
            <Text fontFamily='Comfortaa' fontWeight='bold' fontSize='18px' color='#121826'>
              KPI
            </Text>
          </Flex>
        ) : widget?.instrument_type === 'line' ||
          widget?.instrument_type === 'bar' ||
          widget?.instrument_type === 'stack' ? (
          <Flex alignItems={'center'} gap='11px'>
            <FigmaChartIcon width={18} height={18} color={'#121826'} />
            <Text fontFamily='Comfortaa' fontWeight='bold' fontSize='18px' color='#121826'>
              Chart
            </Text>
          </Flex>
        ) : widget?.instrument_type === 'table' ? (
          <Flex alignItems={'center'} gap='11px'>
            <FigmaTableIcon width={18} height={18} color={'#121826'} />
            <Text fontFamily='Comfortaa' fontWeight='bold' fontSize='18px' color='#121826'>
              Table
            </Text>
          </Flex>
        ) : widget?.instrument_type === 'variance' ? (
          <Flex alignItems={'center'} gap='11px'>
            <FigmaVarianceIcon width={18} height={18} color={'#121826'} />
            <Text fontFamily='Comfortaa' fontWeight='bold' fontSize='18px' color='#121826'>
              Variance
            </Text>
          </Flex>
        ) : (
          <Flex alignItems={'center'} gap='11px'>
            <TextBoxIconComponent width={'18px'} height={'18px'} color={'#121826'} />
            <Text fontFamily='Comfortaa' fontWeight='bold' fontSize='18px' color='#121826'>
              Text
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default DashboardModalHeading;
